import React, { useEffect, useState } from "react";
import { Button } from "../../components/Button/Button";
import { AiOutlineApartment, AiOutlineHistory } from "react-icons/ai";
import { BsPerson } from "react-icons/bs";
import { IoNewspaperOutline } from "react-icons/io5";
import { ImAttachment } from "react-icons/im";
import { useTranslation } from "react-i18next";
import { BadgeNotificate } from "../../components/AntdControlComponent/BadgeNotificateComponent/BadgeNotificate";
interface Props {
  curPage: any;
  onSelectView: (text: string) => void;
  workList?: any;
  requestData?: any
}
const RequestSideBarElement = (props: Props) => {
  const [sidebar, setSidebar] = useState<any[]>([]);
  const [sidebarM, setSidebarM] = useState<any[]>([]);
  const { t } = useTranslation(["translation"]);
  useEffect(() => {
    const SideBarData = [
      {
        component: (
          <Button
            onSelectView={(e) => props.onSelectView(e)}
            title={t("Requestor")!}
            icon={<BsPerson />}
            page={1}
            curPage={props.curPage}
          />
        ),
      },
      {
        component: (
          <Button
            onSelectView={(e) => props.onSelectView(e)}
            title={t("information")!}
            icon={<IoNewspaperOutline />}
            page={2}
            curPage={props.curPage}
          />
        ),
      },
      {
        component: (
          <Button
            onSelectView={(e) => props.onSelectView(e)}
            title={t("lineApprovals")!}
            icon={<AiOutlineApartment />}
            page={3}
            curPage={props.curPage}
          />
        ),
      },
      {
        component: (
          <BadgeNotificate
            dataMemo={null}
            type="attachment"
            requestData={props.requestData}
            dataDetail={null}
            isCard={true}
            children={
              <Button
                onSelectView={(e) => props.onSelectView(e)}
                title={t("attachment")!}
                icon={<ImAttachment />}
                page={4}
                curPage={props.curPage}
                children={null}
              />
            }
          />
          
        ),
      },
    ];

    const SideBarDataResponsive = [
      {
        component: (
          <Button
            onSelectView={(e) => props.onSelectView(e)}
            icon={<BsPerson />}
            page={1}
            title={""}
            curPage={props.curPage}
          />
        ),
      },
      {
        component: (
          <Button
            onSelectView={(e) => props.onSelectView(e)}
            icon={<IoNewspaperOutline />}
            title={""}
            page={2}
            curPage={props.curPage}
          />
        ),
      },
      {
        component: (
          <Button
            onSelectView={(e) => props.onSelectView(e)}
            icon={<AiOutlineApartment />}
            page={3}
            title={""}
            curPage={props.curPage}
          />
        ),
      },
      {
        component: (
          <BadgeNotificate
            dataMemo={null}
            type="attachment"
            requestData={props.requestData}
            dataDetail={null}
            badgeSize="small"
            offset={[0, 35]}
            children={
              <Button
                onSelectView={(e) => props.onSelectView(e)}
                icon={<ImAttachment />}
                page={4}
                title={""}
                curPage={props.curPage}
              />
            } 
          />
          
        ),
      },
    ];
    if (props.workList !== undefined && props.workList !== 0) {
      SideBarData.push({
        component: (
          <BadgeNotificate
            dataMemo={null}
            type="history"
            requestData={props.requestData}
            dataDetail={null}
            isCard={true}
            children={
              <Button
                onSelectView={(e) => props.onSelectView(e)}
                title={t("history")!}
                icon={<AiOutlineHistory />}
                page={5}
                curPage={props.curPage}
                children={null}
              />
            }
          />
        ),
      });
      SideBarDataResponsive.push({
        component: (
          <BadgeNotificate
            type="history"
            requestData={props.requestData}
            dataDetail={null}
            badgeSize="small"
            offset={[0, 35]}
            dataMemo={null}
            children={
              <Button
                onSelectView={(e) => props.onSelectView(e)}
                icon={<AiOutlineHistory />}
                page={5}
                curPage={props.curPage}
                title={""}
              />
            }
          />
        ),
      });
    }
    setSidebar([...SideBarData]);
    setSidebarM([...SideBarDataResponsive]);
  }, [props.workList, props.curPage, t]);

  return (
    <>
      <div className="Sidebar RequestSideBarElement-display-none">
        {sidebar.map((data, idx) => (
          <div key={idx}>{data.component}</div>
        ))}
      </div>
      <div className="Sidebar RequestSideBarElement-display-inline">
        {sidebarM.map((data, idx) => (
          <div key={idx} style={{ padding: " 0 10px 0px 0px" }}>
            {data.component}
          </div>
        ))}
      </div>
    </>
  );
};

export default RequestSideBarElement;
